/**
 * File navigation.js.
 */
(function () {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 200) {
            document.body.classList.add('has-sticky-header');
            document.body.classList.remove('has-sticky-header-animate-out');
            document.body.classList.add('has-sticky-header-animate-in');
        } else {
            document.body.classList.remove('has-sticky-header-animate-in');
            document.body.classList.add('has-sticky-header-animate-out');
            document.body.classList.remove('has-sticky-header');
        }
    });

    document.querySelectorAll('.menu-btn').forEach((menu) => {
        menu.addEventListener('click', () => {
            document.body.classList.toggle('mobile-menu-open');
        });
    });

    document.body.querySelectorAll('li.menu-item-has-children .toggle-sub-menu').forEach((menuToggleItems) => {
        menuToggleItems.addEventListener('click', () => {
            const parent = menuToggleItems.parentElement;
            if (parent) {
                parent.classList.toggle('sub-menu-open');
            }
        });
    });
}());
